/* Back in Stock для leia.ua — «Повідомити, коли зʼявиться в наявності».
 *
 * Пише напряму в Cloud Firestore через REST, без Firebase SDK: усю валідацію
 * робить Security Rules на боці Google. Публічний apiKey тут не є секретом —
 * колекція закрита на читання (read: if false), витягти з неї нічого не можна.
 *
 * Коди відповіді, на які спираємось (перевірені на живих правилах):
 *   200                    → заявку створено
 *   409 ALREADY_EXISTS     → вже підписаний, шлемо transform-інкремент лічильника
 *   403 PERMISSION_DENIED  → правила відхилили дані, це справжня помилка
 */
(function () {
  'use strict';

  var LS_KEY = 'leia_bis_v1';
  var LS_TTL = 90 * 24 * 60 * 60 * 1000; // 90 днів
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/;
  var TIMEOUT = 10000;
  /* Менеджер паролів заповнює поля миттєво, тож поріг тримаємо низьким:
     краще пропустити рідкісного бота, ніж викинути живу заявку. */
  var MIN_OPEN_MS = 900;

  /* ---------------------------------------------------------- утиліти */

  function normalizePhone(raw) {
    var s = String(raw || '').trim();
    if (!s) return null;                          // поле порожнє — це нормально
    var d = s.replace(/\D/g, '');
    /* Щось ввели, але жодної цифри (наприклад літери). Мовчки вважати це
       порожнім полем не можна: людина думає, що залишила номер, а він зникає. */
    if (!d) return false;
    if (/^380\d{9}$/.test(d)) return '+' + d;
    if (/^0\d{9}$/.test(d)) return '+38' + d;
    if (/^\d{9}$/.test(d)) return '+380' + d;
    return false;                                 // вказано, але не розпізнали
  }

  function hashHex(str) {
    if (window.crypto && crypto.subtle) {
      return crypto.subtle
        .digest('SHA-256', new TextEncoder().encode(str))
        .then(function (buf) {
          return Array.prototype.map
            .call(new Uint8Array(buf), function (b) {
              return ('0' + b.toString(16)).slice(-2);
            })
            .join('');
        });
    }
    // запасний варіант для екзотичних середовищ без SubtleCrypto
    var h1 = 0x811c9dc5, h2 = 0x01000193;
    for (var i = 0; i < str.length; i++) {
      h1 = (h1 ^ str.charCodeAt(i)) >>> 0;
      h1 = (h1 * 0x01000193) >>> 0;
      h2 = (h2 + str.charCodeAt(i) * (i + 7)) >>> 0;
    }
    return Promise.resolve(
      ('00000000' + h1.toString(16)).slice(-8) +
      ('00000000' + h2.toString(16)).slice(-8) +
      ('00000000' + (str.length * 2654435761 >>> 0).toString(16)).slice(-8)
    );
  }

  function lsRead() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return {};
      var data = JSON.parse(raw);
      var now = Date.now(), changed = false;
      for (var k in data) {
        if (now - data[k] > LS_TTL) { delete data[k]; changed = true; }
      }
      if (changed) localStorage.setItem(LS_KEY, JSON.stringify(data));
      return data;
    } catch (e) { return {}; }
  }

  function lsMark(variantId) {
    try {
      var data = lsRead();
      data[variantId] = Date.now();
      localStorage.setItem(LS_KEY, JSON.stringify(data));
    } catch (e) { /* приватний режим Safari — не критично */ }
  }

  /* ------------------------------------------- кодування у формат Firestore */

  function fsValue(v) {
    if (typeof v === 'boolean') return { booleanValue: v };
    if (typeof v === 'number') return { integerValue: String(v) };
    return { stringValue: String(v) };
  }

  function fsFields(obj) {
    var out = {};
    for (var k in obj) {
      if (obj[k] !== null && obj[k] !== undefined && obj[k] !== '') out[k] = fsValue(obj[k]);
    }
    return out;
  }

  function abortAfter(ms) {
    var ctl = new AbortController();
    var timer = setTimeout(function () { ctl.abort(); }, ms);
    return { signal: ctl.signal, clear: function () { clearTimeout(timer); } };
  }

  /* ------------------------------------------------------ кастом-елемент */

  class NotifyWhenAvailable extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;

      this.sectionId = this.dataset.section;
      this.project = this.dataset.project;
      this.apiKey = this.dataset.apiKey;
      this.collection = this.dataset.collection;

      try {
        this.variants = JSON.parse(this.querySelector('[data-nwa-variants]').textContent);
      } catch (e) {
        this.variants = {};
      }

      this.toggleBtn = this.querySelector('[data-nwa-toggle]');
      this.panel = this.querySelector('[data-nwa-panel]');
      this.form = this.querySelector('[data-nwa-form]');
      this.done = this.querySelector('[data-nwa-done]');
      this.doneText = this.querySelector('[data-nwa-done-text]');
      this.msg = this.querySelector('[data-nwa-msg]');
      this.submitBtn = this.querySelector('[data-nwa-submit]');
      this.phoneIn = this.querySelector('[data-nwa-phone]');
      this.emailIn = this.querySelector('[data-nwa-email]');
      this.hp = this.querySelector('[data-nwa-hp]');
      this.privacyIn = this.querySelector('[data-nwa-privacy]');
      this.marketingIn = this.querySelector('[data-nwa-marketing]');

      this.alwaysOpen = this.dataset.alwaysOpen === 'true';
      this.openedAt = 0;
      this.sending = false;

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', this.open.bind(this));
      }
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
      [this.phoneIn, this.emailIn].forEach(function (el) {
        if (el) el.addEventListener('input', function () { this.clearFieldError(el); }.bind(this));
      }, this);

      document.addEventListener('leia:bis:open', this.scrollAndOpen.bind(this));
      this.initStickyButton();

      this.bindVariantEvents();
      this.applyVariant(this.currentVariantId(), true);

      if (this.alwaysOpen) this.open();
    }

    /* Липка панель купівлі (є і на мобільних, і на ПК — position:fixed без медіа-запиту).
       На розпроданому товарі там висить неактивне «Розпродано», і людина, яка прокрутила
       вниз читати опис, до форми вже не дістанеться. Кнопку додаємо з JS, щоб не чіпати
       6000-рядкову секцію: менше ризику і вся логіка показу лишається в одному місці. */
    initStickyButton() {
      var bar = document.querySelector('sticky-buy-button');
      var themeBtn = bar && bar.querySelector('.wt-product__sticky-buy__button');
      if (!themeBtn || !themeBtn.parentNode) return;

      var b = document.createElement('button');
      /* type="button" і БЕЗ атрибута form — інакше кнопка відправить форму купівлі */
      b.type = 'button';
      b.className = 'wt-product__sticky-buy__button button button--primary nwa__sticky-btn';
      b.hidden = true;
      b.textContent = this.dataset.textSticky || 'Повідомити про наявність';
      b.addEventListener('click', this.scrollAndOpen.bind(this));

      themeBtn.parentNode.insertBefore(b, themeBtn.nextSibling);
      this.stickyBtn = b;
      this.stickyThemeBtn = themeBtn;
    }

    syncSticky() {
      if (!this.stickyBtn) return;
      var needNotify = !this.hidden;
      this.stickyBtn.hidden = !needNotify;
      // ховаємо неактивне «Розпродано», щоб у панелі не було двох кнопок поряд
      if (this.stickyThemeBtn) this.stickyThemeBtn.style.display = needNotify ? 'none' : '';
    }

    /* поточний варіант беремо з прихованого input форми покупки — там завжди правда */
    currentVariantId() {
      var form = document.getElementById('product-form-' + this.sectionId);
      var input = form && form.querySelector('input[name="id"]');
      return (input && input.value) || this.dataset.variantId || '';
    }

    /* pubsub теми вантажиться з defer — підписку робимо з ретраєм,
       інакше на повільному зʼєднанні підписка просто не встигне навісити */
    bindVariantEvents() {
      var self = this, tries = 0;
      (function bind() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
          if (tries++ < 60) return requestAnimationFrame(bind);
          return; // деградуємо: форма працює, але не реагує на зміну варіанта
        }
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
          var d = evt && evt.data;
          if (!d || String(d.sectionId) !== String(self.sectionId)) return;
          self.applyVariant(d.variant && d.variant.id, false);
        });
      })();

      /* Комбінація опцій, якої не існує: variantChange не публікується взагалі,
         тема лише викликає setUnavailable(). Ловимо це по тексту кнопки купівлі.
         Читати прихований input тут не можна — variantChangeEnd летить синхронно,
         ДО того як renderProductInfo() дорезолвить свій fetch, тобто значення
         там ще старе. Тому цією гілкою тільки ховаємо, ніколи не показуємо. */
      document.addEventListener('variantChangeEnd', function () {
        var strings = window.variantStrings;
        if (!strings || !strings.unavailable) return;
        var form = document.getElementById('product-form-' + self.sectionId);
        var span = form && form.querySelector('[name="add"] > span');
        if (span && span.textContent.trim() === String(strings.unavailable).trim()) {
          self.hidden = true;
        }
      });
    }

    applyVariant(variantId, initial) {
      var v = this.variants[String(variantId || '')];

      /* Орієнтуємось на БАЗОВИЙ варіант («Стандарт»), а не на вибраний.
         Бандл буває розпроданий лише тому, що скінчився інший товар у наборі —
         сам товар при цьому в наявності, і повідомляти нема про що.
         Підписка теж іде на базовий варіант: чекають саме на нього. */
      var base = v ? this.variants[String(v.b)] : null;
      var id = base ? String(v.b) : '';

      this.variantId = id;
      this.variantTitle = base ? base.t : '';
      this.variantSku = base ? base.s : '';

      this.hidden = !base || base.a === true;
      this.syncSticky();          // до раннього виходу: панель треба оновити в обох випадках
      if (this.hidden) return;

      if (!initial) this.reset();

      // вже підписаний із цього браузера — одразу показуємо це
      if (lsRead()[id]) this.showDone(this.dataset.textAlready);
    }

    reset() {
      this.sending = false;
      if (this.form) { this.form.hidden = false; this.form.reset(); }
      if (this.done) this.done.hidden = true;
      if (this.msg) { this.msg.textContent = ''; this.msg.classList.remove('is-error'); }
      if (this.submitBtn) this.submitBtn.disabled = false;
      if (!this.alwaysOpen && this.panel) {
        this.panel.hidden = true;
        if (this.toggleBtn) this.toggleBtn.hidden = false;
      }
      this.clearFieldError(this.phoneIn);
      this.clearFieldError(this.emailIn);
    }

    open() {
      if (!this.panel) return;
      this.panel.hidden = false;
      if (this.toggleBtn) this.toggleBtn.hidden = true;
      this.openedAt = Date.now();
      var first = this.phoneIn || this.emailIn;
      if (first && !this.alwaysOpen) first.focus({ preventScroll: true });
    }

    scrollAndOpen() {
      if (this.hidden) return;
      this.open();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* -------------------------------------------------------- помилки полів */

    fieldError(input, text) {
      if (!input) return;
      input.setAttribute('aria-invalid', 'true');
      var err = input.parentNode.querySelector('[data-nwa-err]');
      if (err) { err.textContent = text; err.classList.add('is-shown'); }
    }

    clearFieldError(input) {
      if (!input) return;
      input.removeAttribute('aria-invalid');
      var err = input.parentNode.querySelector('[data-nwa-err]');
      if (err) { err.textContent = ''; err.classList.remove('is-shown'); }
    }

    say(text, isError) {
      if (!this.msg) return;
      this.msg.textContent = text || '';
      this.msg.classList.toggle('is-error', !!isError);
    }

    showDone(text) {
      if (this.form) this.form.hidden = true;
      if (this.done) this.done.hidden = false;
      if (this.doneText) this.doneText.textContent = text;
      if (this.panel) this.panel.hidden = false;
      if (this.toggleBtn) this.toggleBtn.hidden = true;
    }

    /* ------------------------------------------------------------ надсилання */

    onSubmit(e) {
      e.preventDefault();
      if (this.sending) return;

      /* Пастка для ботів + надто швидке заповнення: вдаємо успіх, нічого не пишемо.
         console.warn обовʼязковий: без нього тиха втрата заявки не діагностується —
         саме так автозаповнення браузера довго ковтало живі підписки. */
      if (this.hp && this.hp.value) {
        console.warn('[back-in-stock] honeypot спрацював, заявку не надіслано');
        this.showDone(this.dataset.textSuccess);
        return;
      }
      if (this.openedAt && Date.now() - this.openedAt < MIN_OPEN_MS) {
        console.warn('[back-in-stock] форму заповнено надто швидко, заявку не надіслано');
        this.showDone(this.dataset.textSuccess);
        return;
      }

      this.clearFieldError(this.phoneIn);
      this.clearFieldError(this.emailIn);
      this.say('');

      var email = (this.emailIn && this.emailIn.value || '').trim().toLowerCase();
      var phoneRaw = (this.phoneIn && this.phoneIn.value || '').trim();
      var phone = normalizePhone(phoneRaw);
      var bad = false;

      if (phone === false) { this.fieldError(this.phoneIn, this.dataset.textErrPhone); bad = true; }
      if (email && !EMAIL_RE.test(email)) {
        this.fieldError(this.emailIn, this.dataset.textErrEmail); bad = true;
      }
      if (!bad && !email && !phone) {
        this.fieldError(this.phoneIn, this.dataset.textErrContact); bad = true;
      }
      if (this.privacyIn && !this.privacyIn.checked) {
        this.say(this.dataset.textErrConsent, true); bad = true;
      }
      if (bad) return;

      this.sending = true;
      if (this.submitBtn) this.submitBtn.disabled = true;
      this.say(this.dataset.textSending);

      var self = this;
      this.send(email || null, phone || null)
        .then(function (outcome) {
          lsMark(self.variantId);
          self.showDone(outcome === 'already' ? self.dataset.textAlready : self.dataset.textSuccess);
          self.track(email, phone);
          // Klaviyo — ТІЛЬКИ після успішного запису в Firestore і тільки як
          // побічний ефект: якщо Klaviyo лежить, заявка вже збережена, лід не втрачено
          self.klaviyo(email, phone);
        })
        .catch(function (err) {
          self.sending = false;
          if (self.submitBtn) self.submitBtn.disabled = false;
          self.say(self.dataset.textErrGeneric, true);
          if (window.console) console.error('[back-in-stock]', err);
        });
    }

    send(email, phone) {
      var self = this;
      var base = 'https://firestore.googleapis.com/v1/projects/' + this.project +
                 '/databases/(default)/documents';
      var url = base + ':commit?key=' + encodeURIComponent(this.apiKey);
      var docPath = 'projects/' + this.project + '/databases/(default)/documents/' +
                    this.collection + '/';

      return hashHex(email || phone).then(function (h) {
        var name = docPath + self.variantId + '_' + h.slice(0, 32);

        var fields = fsFields({
          productId: parseInt(self.dataset.productId, 10),
          productHandle: self.dataset.productHandle,
          productTitle: self.dataset.productTitle,
          variantId: parseInt(self.variantId, 10),
          variantTitle: self.variantTitle,
          variantSku: self.variantSku,
          email: email,
          phone: phone,
          locale: self.dataset.locale,
          pageUrl: location.href.slice(0, 500),
          status: 'pending',
          requestCount: 1
        });
        fields.consentPrivacy = { booleanValue: true };
        fields.consentMarketing = {
          booleanValue: !!(self.marketingIn && self.marketingIn.checked)
        };

        var createBody = {
          writes: [{
            update: { name: name, fields: fields },
            updateTransforms: [
              { fieldPath: 'createdAt', setToServerValue: 'REQUEST_TIME' },
              { fieldPath: 'lastRequestAt', setToServerValue: 'REQUEST_TIME' }
            ],
            currentDocument: { exists: false }
          }]
        };

        var t = abortAfter(TIMEOUT);
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(createBody),
          signal: t.signal
        }).then(function (res) {
          t.clear();
          if (res.ok) return 'created';

          // 409 — документ уже є: та сама людина на той самий варіант.
          // Лічильник інкрементуємо серверним transform: прочитати поточне
          // значення ми не можемо, колекція закрита на читання.
          if (res.status === 409) {
            var bumpBody = {
              writes: [{
                update: { name: name, fields: {} },
                updateMask: { fieldPaths: [] },
                updateTransforms: [
                  { fieldPath: 'requestCount', increment: { integerValue: '1' } },
                  { fieldPath: 'lastRequestAt', setToServerValue: 'REQUEST_TIME' }
                ],
                currentDocument: { exists: true }
              }]
            };
            return fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(bumpBody)
            }).then(function () { return 'already'; });
          }

          return res.text().then(function (body) {
            throw new Error('Firestore ' + res.status + ': ' + body.slice(0, 300));
          });
        });
      });
    }

    /* Klaviyo — додатковий отримувач, не джерело правди.
       Усі виклики best-effort: помилки глушаться, підписку вони зламати не можуть. */
    klaviyo(email, phone) {
      var cid = this.dataset.klaviyoCompany;
      if (!cid) return;
      /* Без email у Klaviyo не йде нічого: розсилати нема куди (SMS в Україну
         Klaviyo не шле), а профіль без каналу — мертвий вантаж. Такі заявки
         живуть у Firestore і потрапляють в експорт для ручного контакту. */
      if (!email) return;
      var rev = this.dataset.klaviyoRevision || '2025-07-15';
      var listId = this.dataset.klaviyoList;

      var post = function (path, body) {
        try {
          fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cid), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: rev },
            body: JSON.stringify(body),
            keepalive: true
          }).catch(function () {});
        } catch (e) { /* глухо */ }
      };

      /* Привʼязати браузер до профілю Klaviyo — так само, як це роблять футер,
         lead-попап і кастомний чекаут. Без identify підписка створює профіль,
         але візитер лишається анонімним, і Klaviyo мовчки викидає всі
         onsite-події (Viewed Product / Added to Cart / Active on Site).
         identify НЕ підписує на розсилку — це лише привʼязка браузера. */
      try {
        var idAttrs = { $email: email };
        if (phone) idAttrs.$phone_number = phone;
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify(idAttrs);
        } else {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', idAttrs]);
        }
      } catch (e) { /* трекінг не має ламати підписку */ }

      var ident = {};
      if (email) ident.email = email;
      if (phone) ident.phone_number = phone;

      /* Подія. Тільки вона несе, ЯКИЙ саме товар чекають — список цього не зберігає. */
      post('events', {
        data: {
          type: 'event',
          attributes: {
            properties: {
              ProductTitle: this.dataset.productTitle,
              ProductHandle: this.dataset.productHandle,
              ProductID: this.dataset.productId,
              VariantID: this.variantId,
              VariantTitle: this.variantTitle,
              VariantSKU: this.variantSku,
              ProductURL: location.origin + '/products/' + this.dataset.productHandle +
                          '?variant=' + this.variantId,
              Channels: [email ? 'email' : null, phone ? 'phone' : null].filter(Boolean).join('+')
            },
            metric: { data: { type: 'metric', attributes: { name: 'Requested Back In Stock' } } },
            profile: { data: { type: 'profile', attributes: ident } }
          }
        }
      });

      if (!listId) return;

      /* Підписка в список з явною згодою на email-маркетинг.
         Телефон, якщо він є, кладемо в профіль як атрибут — але SMS-згоду
         не фіксуємо: Klaviyo не розсилає SMS в Україну, і згода, якою не
         скористаєшся, лише засмічує базу. */
      var prof = {
        email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
        /* lead_source — та сама властивість, що у футера («Footer Newsletter»)
           і lead-попапа («Lead Popup»): щоб джерела ліда лишались порівнюваними */
        properties: { lead_source: 'Back in Stock' }
      };
      if (phone) prof.phone_number = phone;

      post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Back in Stock: ' + (this.dataset.productTitle || ''),
            profile: { data: { type: 'profile', attributes: prof } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      });
    }

    track(email, phone) {
      try {
        var channels = [];
        if (email) channels.push('email');
        if (phone) channels.push('phone');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'back_in_stock_subscribe',
          product_id: this.dataset.productId,
          product_name: this.dataset.productTitle,
          variant_id: this.variantId,
          variant_name: this.variantTitle,
          channels: channels.join('+')
        });
      } catch (e) { /* трекінг не має ламати підписку */ }
    }
  }

  if (!customElements.get('notify-when-available')) {
    customElements.define('notify-when-available', NotifyWhenAvailable);
  }
})();
